module.exports = __webpack_public_path__ + "img/logo.26220e42.png";